import React, { useState } from 'react';
import { Box } from '@mui/material';
import AppBarComponent from '../components/AppBar';
import DrawerMenu from '../components/DrawerMenu';

function AppLayout({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Box sx={{ minHeight: '100vh', width: '100vw', position: 'relative', overflow: 'hidden' }}>
      <Box
        component="img"
        src="/background.jpg"
        alt=""
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          objectFit: 'cover',
          zIndex: 0,
          opacity: 0.5,
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      />
      <Box sx={{ position: 'relative', zIndex: 1, minHeight: '100vh' }}>
        <AppBarComponent onDrawerOpen={() => setDrawerOpen(true)} />
        <DrawerMenu open={drawerOpen} onClose={() => setDrawerOpen(false)} />
        <Box sx={{ width: '100%', maxWidth: 1200, mx: 'auto', px: { xs: 1, sm: 2.5 }, pb: 3 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export default AppLayout;
